import React, { useEffect, useState, useContext } from 'react';
import { Modal, Upload } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import { beforeUploadProductImg } from '../product/helper';
import { GroupProductContenxt } from './ProductDataContext';

const SingleImageUpload = ({ onChange }) => {
  const productGroupContext = useContext(GroupProductContenxt);
  const [state, setState] = useState({
    previewVisible: false,
    previewImage: '',
    previewTitle: '',
    fileList: [
      // {
      //   uid: "-1",
      //   name: "image.png",
      //   status: "done",
      //   url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
      // }
    ],
  });

  // Хуулж дуустал товч дээр ачаалж буйг харуулж, давхар сонгохоос сэргийлнэ
  const [uploading, setUploading] = useState(false);

  /**
   * Хуудсаа refresh хийхэд өмнө нь оруулсан зураг харагдана — зургийн хаяг нь
   * контекстэд (draft) хадгалагдсан байдаг.
   */
  useEffect(() => {
    const image = productGroupContext?.labelInfo?.productItem?.image;
    if (image) {
      setState((prev) => ({ ...prev, fileList: [{ status: 'done', url: image }] }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    onChange(state.fileList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.fileList]);

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  const handleCancel = () => setState((prev) => ({ ...prev, previewVisible: false }));

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setState((prev) => ({
      ...prev,
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle: file.name || (file.url ? file.url.substring(file.url.lastIndexOf('/') + 1) : ''),
    }));
  };

  /**
   * `fileList` нь бүрэн контролтой тул antd өөрөө устгаж чадахгүй — устгахыг
   * энд гүйцэтгэнэ. Өмнө нь `onRemove`/`onChange` аль нь ч холбогдоогүй байсан
   * тул «Файл устгах» товч юу ч хийдэггүй, буруу зураг сонгосон хэрэглэгч
   * солих боломжгүй байв.
   */
  const handleRemove = () => {
    setState((prev) => ({ ...prev, fileList: [] }));
    productGroupContext?.changeLevelInfo?.('productItem', 'image', '');
    return true;
  };

  const { previewVisible, previewImage, fileList, previewTitle } = state;
  const uploadButton = (
    <div style={{}}>
      {uploading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ color: 'rgba(0, 0, 0, 0.45)' }}>Оруулах</div>
    </div>
  );

  // const handleChange = ({ fileList }) => setState({ fileList });
  return (
    <>
      <Upload
        // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
        listType="picture-card"
        fileList={fileList}
        // Нэгж бараатай ижил шалгуур: формат ба хэмжээг ЗААГЛАН хэлнэ. Өмнө нь
        // энд ямар ч шалгалт байгаагүй тул буруу формат, хэт том файл хоёуланд
        // нь ерөнхий «Алдаа гарлаа» гарч, юуг засахаа мэдэх аргагүй байв.
        beforeUpload={beforeUploadProductImg}
        onPreview={handlePreview}
        onRemove={handleRemove}
        disabled={uploading}
        customRequest={async ({ file }) => {
          setUploading(true);
          try {
            const formData = new FormData();
            formData.append('file', file);
            const res = await axios({
              method: 'post',
              url: `${
                process.env.REACT_APP_STORAGE_URL
              }/upload/operator/product?fileName=product${Date.now()}&uid=${file.uid}`,
              data: formData,
            });
            const imagePath = res?.data?.result?.location ?? '';
            setState((prev) => ({
              ...prev,
              fileList: [
                ...prev.fileList,
                {
                  uid: file.uid,
                  name: file.name,
                  status: 'done',
                  url: imagePath,
                },
              ],
            }));
            productGroupContext.changeLevelInfo('productItem', 'image', imagePath);

            return imagePath;
          } finally {
            setUploading(false);
          }
        }}
      >
        {fileList.length >= 1 ? null : uploadButton}
      </Upload>
      <Modal visible={previewVisible} title={previewTitle} footer={null} onCancel={handleCancel}>
        <img alt={previewTitle || 'Зургийн урьдчилсан харагдац'} style={{ width: '100%' }} src={previewImage} />
      </Modal>
    </>
  );
};
export default SingleImageUpload;
